import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { analyzeAndValidateNgModules, Type } from "@angular/compiler";
import { map } from "rxjs/operators";
import * as $ from "jquery";

@Injectable({
  providedIn: "root"
})
export class ApiService {
  // BaseURL: string = "http://hdrx.23byt.es/api/v2/";
  // BaseURL: string = "http://rxhacker.23byt.es/api/v2/";
  // BaseURL1: string = "http://rxhacker.23byt.es/api/v3/";
  BaseURL: string =  "https://littleangelhands-api.rxhacker.com/api/v2/";
  BaseURL1: string = "https://littleangelhands-api.rxhacker.com/api/v3/";
  /* newsletter email save to google sheet functionality */
  googleSheetApi =
    "https://script.google.com/macros/s/AKfycbzZKapInrPeLM9DG8JSChDkO7L3UdBQQwwOunrauCnQGBt67PFB/exec";

  googleSheetData() {
    var googleSheetForm = $("#submit-to-google-sheet");
    var jqxhr = $.ajax({
      url: this.googleSheetApi,
      method: "GET",
      dataType: "json",
      data: googleSheetForm.serialize()
    });
  }

  constructor(public http1: HttpClient, public http: Http) {}

  SearchDrugList(searchtext) {
    var Encode_DrugName = encodeURIComponent(searchtext);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL + "searchdrug",
      "stext=" + Encode_DrugName,
      {
        headers: headers
      }
    );
  }
  GetPopularDrug() {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL + "populardrug", "DrugName=" + "test", {
      headers: headers
    });
  }
  GetDrugDetails(DrugName) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL + "drugcomponents",
      "DrugName=" + Encode_DrugName,
      { headers: headers }
    );
  }
  addActiveContact(email, first_name, last_name, tags) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append("No-Auth", "True");
    const body = new URLSearchParams();
    body.set("email", email);
    body.set("first_name", first_name);
    body.set("last_name", last_name);
    body.set("tags", tags);
    // headers.append(
    //   "Content-Type",
    //   "application/x-www-form-urlencoded; charset=utf-8"
    // );
    return this.http.post(
      "https://cors.23byt.es/https://valpaksi.api-us1.com/admin/api.php?api_action=contact_add&api_key=84747226ebba49bee437d9460570432594890916bcd02276a010033c5589579274b27e15&api_output=json",
      body.toString(),
      { headers: headers }
    );
  }
  sendEmail(email, name, Message) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      "Bearer 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"
    );
    let body = {
      from: {
        email: email,
        name: name
      },
      personalizations: [
        {
          to: [
            {
              email: "support@glichealth.com"
            }
          ],
          dynamic_template_data: {
            receipt: true,
            name: name,
            email: email,
            Message: Message
          }
        }
      ],
      template_id: "d-1d9b2954146c4867a498753f6ab32fe9"
    };
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  sendEmailContact(email, name, Message) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    
    let body = {
      "name":name,"email":email,"message":Message
    };
    return this.http.post(
      "https://cors.23byt.es/"+ this.BaseURL1+"contact",
      body,
      { headers: headers }
    );
  }
  sendHelp(email, name, Message) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      "Bearer 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"
    );
    let body = {
      from: {
        email: email,
        name: name
      },
      personalizations: [
        {
          to: [
            {
              email: "support@honestdiscounts.com"
              // email: "abhay@23byt.es"
            }
          ],
          dynamic_template_data: {
            receipt: true,
            name: name,
            email: email,
            Message: Message
          }
        }
      ],
      template_id: "d-6f3d0b6c46944d6d951a88b0289c79e1"
    };
    // body.set("email", email);
    // body.set("first_name", first_name);
    // body.set("last_name", last_name);
    // body.set("tags", tags);
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  sendSms(mobileno) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append(
      "Authorization",
      "Basic " +
        btoa(
          "AC2f03c2edaf3af88d1c3edb84608d0697: a6532949dd889ad71af9c88ae6b92ed7"
        )
    );
    const body = new URLSearchParams();
    body.set("To", mobileno);
    body.set(
      "Body",
      "Download our app to click this link https://play.google.com/store/apps/details?id=com.firebase.honest"
    );
    body.set("From", "(707) 234 - 4163)");
    // headers.append(
    //   "Content-Type",
    //   "application/x-www-form-urlencoded; charset=utf-8"
    // );
    return this.http.post(
      "https://cors.23byt.es/https://api.twilio.com/2010-04-01/Accounts/AC2f03c2edaf3af88d1c3edb84608d0697/Messages.json",
      body.toString(),
      { headers: headers }
    );
  }
  SendChromeemail(link, email) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = { "link": link, "email": email }
    return this.http.post(
      "https://cors.23byt.es/https://hdrx.23byt.es/api/v3/walletmail",
      body,
      { headers: headers }
    );
  }
  googlegeneric(bin, pcn, group, memberid) {
    const headers = new Headers();
    let dl = window.localStorage.getItem("lahrx_DeepLinkURL");
    headers.append("Content-Type", "application/json");
    let body = {"bin":bin, "pcn":pcn, "group":group, "memberid":memberid, "appname":"RxHacker"}
    return this.http.post(
      "https://cors.23byt.es/https://passes.23byt.es/api/v1/pass/google_generic_pass",
      body,
      { headers: headers }
    );
  }
  applegeneric(bin, pcn, group, memberid) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {"bin":bin, "pcn":pcn, "group":group, "memberid":memberid, "appname":"RxHacker"}
    return this.http.post(
      "https://cors.23byt.es/https://passes.23byt.es/api/v1/pass/apple_generic_pass",
      body,
      { headers: headers }
    );
  }
}
